import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PermitDetail } from '../../../models/permit-detail.model';

/** Research permit detail - project and team. Ethics / WWC / police uploads and the
 *  Research Access Agreement are handled off-portal (TLC, 28 Sep). */
@Component({
    selector: 'app-research-detail',
    templateUrl: './research-detail.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ResearchDetailComponent {
    @Input() permit!: PermitDetail;
}
